const React = require('react');
const PropTypes = require('prop-types');
/**
 * This ActionLink component is useful to avoid creating new bindings on the render functions of the components
 * @param {Object} param Parameter that will be passed down to the onClick callback
 * @param {Object} className Classnames that will be added to the rendered html link element
 * @param {Object} style Styles object that will be added to the rendered html link element
 * @param {Function} onClick Callback that will be called when the html link is clicked
 */

class RAActionLink extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { onClick, param } = this.props;
        onClick && onClick(param);
    }

    render() {
        const { className, style, children } = this.props;

        return (
            <a className={className} style={style} onClick={this.handleClick}>
                {children}
            </a>
        );
    }
}

RAActionLink.propTypes = {
    param: PropTypes.any,
    className: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.any,
    style: PropTypes.any,
};

module.exports = RAActionLink;
